import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import UserForm from "views/organisms/user/form/UserForm"
import { Redirect, useParams } from "react-router-dom"
import UsersEntity from "services/entities/UsersEntity"
import withAuthRequired from "../../components/auth/withAuthRequired"
import { useEntity } from "hooks/useAxios"
import { useAppContext } from "components/AppContext"
import useAdminRules from "hooks/useAdminRules"
import ThreeSectionsSkeletonPage from "views/pages/skeletons/ThreeSectionsSkeletonPage"

const UserUpdatePage = () => {
  const [redirectToUsersList, setRedirectToUsersList] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [errorMessage, setErrorMessage] = useState(null)
  const [errors, setErrors] = useState({})
  const [notFoundUser, setNotFoundUser] = useState(false)
  const [user, setUser] = useState(null)
  const usersEntity = useEntity(UsersEntity)

  const { t } = useTranslation()
  const { currentUser } = useAppContext()
  const { isUserAdmin } = useAdminRules()

  const { id } = useParams()

  useEffect(async () => {
    try {
      const { data } = await usersEntity.getCurrentRootNodeUser(id)
      setUser(data)
    } catch (err) {
      setNotFoundUser(true)
    } finally {
      setIsLoading(false)
    }
  }, [])

  const handleSubmit = async (user) => {
    setIsLoading(true)
    try {
      await usersEntity.updateUserCompany(user)
      setRedirectToUsersList(true)
    } catch (err) {
      setErrors(err.response?.data)
    } finally {
      setIsLoading(false)
    }
  }

  if (redirectToUsersList) {
    return <Redirect to="/users" />
  }

  if (!currentUser || isLoading) return <ThreeSectionsSkeletonPage />

  return (
    <UserForm
      title={t("common:user_update.title")}
      description={t("common:user_update.description")}
      submitTitle={t("common:user_update.submit")}
      onSubmit={handleSubmit}
      onCancel={() => setRedirectToUsersList(true)}
      user={user}
      disabled={!isUserAdmin}
      errors={errors}
    />
  )
}

export default withAuthRequired(UserUpdatePage)
